import { EmptyState } from "../components/primitives/EmptyState";
import { ButtonLink } from "../components/primitives/ButtonLink";

/**
 * The address does not resolve. Rendered inside the shell (spec §5.6) rather
 * than as a bare page, so the nav is still there to leave by.
 */
export function NotFound() {
  return (
    <EmptyState
      title="Nothing at this address."
      action={
        <ButtonLink to="/clients" variant="primary">Go to clients</ButtonLink>
      }
    />
  );
}
